import { SPage } from "servisofts-component";

import root from "./root";
import crear from "./crear";
import lista from "./lista";

export default SPage.combinePages("musculo", {
    "": root,
    "lista": lista,
    crear
})

